import { GetStaticPaths, GetStaticProps } from "next";
import {
  AuthPages,
  Props,
} from "src/components/page-components/AuthPages/AuthPages";

export default AuthPages;

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = [
    { params: { slug: "login" } },
    { params: { slug: "register" } },
    { params: { slug: "registerConfirm" } },
    { params: { slug: "reset" } },
    { params: { slug: "resetConfirm" } },
  ];

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<Props> = async (ctx) => {
  const slug = ctx.params!.slug as string;
  const preview = Boolean(ctx.preview);

  return {
    props: {
      slug,
      preview,
    },
  };
};
